// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add this class to your style.css */
.legend-item .legend-icon.my-views {
  border-color: #808080;
  box-shadow: 0 0 10px rgba(128, 128, 128, 0.5);
  object-fit: cover;
}

/* Existing CSS remains unchanged */
.legend-item .legend-icon.republican {
  border-color: rgba(123, 6, 30, 0.66);
  box-shadow: 0 0 10px rgba(123, 6, 30, 0.66);
  object-fit: cover;
}

.legend-item .legend-icon.democrat {
  border-color: #458BEA;
  box-shadow: 0 0 10px rgba(69, 139, 234, 0.5);
  object-fit: cover;
}

.legend-item .legend-icon.independent {
  border-color: #808080;
  box-shadow: 0 0 10px rgba(128, 128, 128, 0.5);
  object-fit: cover;
}

.legend-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 5px;
  border: 3px solid transparent;
  object-fit: cover;
}

.legend-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 20px;
  width: 100%;
  gap: 20px; /* Add gap between items */
}

.legend-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px;
  width: 140px; /* Increased from 120px */
  min-height: 110px; /* Slightly increased to accommodate more text */
}

.legend-item .legend-icon,
.add-rep-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-bottom: 5px;
}

.legend-item .legend-icon {
  border: 3px solid transparent;
  object-fit: cover;
}

.legend-item p {
  font-size: 0.8em;
  margin-top: 5px;
  word-wrap: break-word;
  max-width: 100%;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Allow up to 3 lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.2em;
  height: 3.6em; /* 3 lines × 1.2em line-height */
}

.add-rep-item {
  position: relative;
  width: 140px; /* Match the width of other legend items */
  cursor: pointer;
}

.add-rep-circle {
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s ease;
  cursor: pointer; /* Add cursor pointer to show it's clickable */
}

.add-rep-circle:hover {
  background-color: #e0e0e0; /* Optional: add hover effect */
}

.add-rep-circle span {
  color: #666;
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
}

.add-rep-search {
  position: absolute;
  left: 100%;
  top: 0;
  width: 400px; /* Increased width */
  margin-left: 10px;
  z-index: 1000;
}

/* Add this new rule to ensure the input takes full width */
.add-rep-search input {
  width: 100%;
  box-sizing: border-box; /* This ensures padding doesn't increase the width */
}

.add-rep-search .suggestions-list {
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-top: none;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.add-rep-search .suggestions-list li {
  padding: 8px;
  cursor: pointer;
}

.add-rep-search .suggestions-list li:hover {
  background-color: #f0f0f0;
}

.add-rep-button {
  background: none;
  border: none;
  color: #458BEA;
  font-size: 1em;
  font-weight: 500;
  cursor: pointer;
  margin-top: 20px;
}

.add-rep-button:hover {
  text-decoration: underline;
}

.compare-reps-container {
  max-width: 1512px;
  display: flex;
  width: 100%;
  padding: 88px 150px;
  gap: 39px;
  background-color: white;
}

.compare-reps-header {
  width: 100%;
  background: linear-gradient(180deg, #458BEA 0%, #6CA8FF 100%);
  color: white;
  text-align: center;
  padding: 40px 0;
}

.compare-reps-header h1 {
  font-size: 3em;
  font-family: 'Georgia', serif;
  font-weight: 700;
  margin: 0;
}

.compare-reps-header p {
  font-size: 1.25em;
  font-weight: 400;
  margin: 10px 0 0 0;
}

.compare-reps-content {
  flex: 1 1;
  margin-right: 20px;
}

.instructions {
  font-size: 1.2em;
  font-weight: 400;
  margin-bottom: 20px;
  color: black;

}

.dropdown-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start; /* Changed to align left */
  gap: 15px;
}

.dropdown {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0px 4px 18.8px -3px rgba(0, 0, 0, 0.102);
  border-radius: 8px;
  border: 1px solid #D9D9D9;
  padding: 0px;
  position: relative;
}

.dropdown label {
  display: none; /* Hide the label text */
}

.dropdown select {
  width: 100%;
  padding: 10px;
  border: 1px solid #D9D9D9;
  border-radius: 5px;
}

.dropdown select::placeholder {
  color: #6C6C6C;
}

.remove-rep-button {
  position: absolute;
  top: 5px;
  right: 5px;
  background: none;
  border: none;
  color: #ff4d4d;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s ease;
}

.remove-rep-button:hover {
  background-color: rgba(255, 77, 77, 0.1);
}

.checkbox-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.checkbox-container input {
  width: 20px;
  height: 20px;
}

.checkbox-container label {
  font-size: 1em;
  font-weight: 400;
  color: #616161;
}

.submit-button {
  background-color: #458BEA !important;
  color: white;
  font-size: 1em;
  font-weight: 700;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}

.submit-button:hover {
  background-color: #357ACD !important;
}

.scores-container {
  text-align: left; /* Changed to align left */
  width: 100%;
}

.separator {
  border: none;
  border-top: 1px solid #D9D9D9;
  margin: 20px 0;
}

.rep-scores {
  margin-bottom: 20px;
}

.rep-scores img {
  max-width: 300px;
  height: auto;
  display: block;
  margin: 10px auto;
}

.back-button {
  margin-top: 20px;
  padding: 10px 20px;
  border: none;
  background-color: #458BEA;
  color: white;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
}

/* Additional CSS for RepresentativeBanner */
.RepresentativeBanner {
  position: relative;
  width: 100%;
  height: 609px; /* Set a fixed height for the banner */
  overflow: hidden; /* Hide any overflow */
}

.placeholder-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensure the image covers the entire container */
  object-position: top; /* Ensure the image starts from the top */
}

@media (max-width: 1224px) {
  /* Styles for screens that are 1500px wide or larger */
  .compare-reps-container {
    display: flex;
    padding: 20px 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 28px;
    width: 100%; /* Changed to align left */
  }
  .scores-container {
    width: 100% !important; /* Changed to align left */
  }
}

/* Add these styles to your existing CSS file */

.input-wrapper {
  position: relative;
  width: 100%;
}

.search-input {
  width: 100%;
  padding: 0px;
  border: none;
  border-radius: 8px;
  background-color: transparent;
  font-size: 14px;
}

.search-input::placeholder {
  color: #6C6C6C;
  font-size: 14px;
}

.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border-top: 1px solid #D9D9D9;
  border-radius: 0 0 8px 8px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0px 4px 18.8px -3px rgba(0, 0, 0, 0.102);
}

.suggestions-list li {
  padding: 10px;
  cursor: pointer;
}

.suggestions-list li:hover {
  background-color: #f0f0f0;
}

/* ... rest of your existing styles ... */

.top-comparisons {

  width: 100%;
  padding: 20px;
  background-color: transparent; /* Removed gray background */
  border-radius: 8px;
  align-self: flex-start;
  max-width: 400px;
}

@media (min-width: 1224px) {
  .top-comparisons {
    width: 100%;
    
  }
}

.top-comparison-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background-color: white;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.top-comparison-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);
}

.rep-images {
  display: flex;
  justify-content: space-around;
  width: 100%;
  gap: 10px;
}

.rep-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1;
}

.rep-image-container .rep-thumb {
  position: static !important;
  transform: none !important;
  width: 48px !important;
  height: 48px !important;
  margin-bottom: 5px;
}

.rep-name {
  font-size: 0.7em;
  color: #333;
  text-align: center;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  max-height: 2.4em;
  overflow: hidden;
  line-height: 1.2em;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 5px;
}

.comparison-count {
  font-size: 0.8em; /* Slightly larger font */
  color: #666;
  margin-top: 8px; /* Increased top margin */
  font-weight: 500; /* Made it a bit bolder */
}

.legend-icon.grayed-out,
.score-thumb.grayed-out {
  opacity: 0.5;
}

.add-rep-circle {
  width: 60px;
  height: 60px;
  background-color: #f0f0f0;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
}

.add-rep-circle span {
  color: #666;
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
}

.add-rep-search {
  margin-top: 10px;
  width: 100%;
  max-width: 500px;
}

.add-rep-search input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.add-rep-search .suggestions-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
}

.add-rep-search .suggestions-list li {
  padding: 8px;
  cursor: pointer;
}

.add-rep-search .suggestions-list li:hover {
  background-color: #f0f0f0;
}

/* Ensure the legend container doesn't overflow */
.legend-container {
  position: relative;
  overflow: visible;
}

/* Adjust layout for smaller screens */
@media (max-width: 1224px) {
  .add-rep-search {
    position: static;
    width: 100%;
    margin-left: 0;
    margin-top: 10px;
  }
}

.new-rep-search-container {
  position: absolute;
  left: 100%;
  top: 0;
  width: 300px;
  margin-left: 10px;
  z-index: 1000;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.new-rep-search-input {
  width: 100%;
  padding: 8px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
}

.new-rep-suggestions-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
}

.new-rep-suggestions-list li {
  padding: 8px;
  cursor: pointer;
}

.new-rep-suggestions-list li:hover {
  background-color: #f0f0f0;
}

`, "",{"version":3,"sources":["webpack://./src/components/CompareRepsSelection/style.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY,EAAE,yBAAyB;EACvC,iBAAiB,EAAE,gDAAgD;AACrE;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB,EAAE,wBAAwB;EAC/C,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,aAAa,EAAE,gCAAgC;AACjD;;AAEA;EACE,kBAAkB;EAClB,YAAY,EAAE,0CAA0C;EACxD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe,EAAE,8CAA8C;AACjE;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY,EAAE,oBAAoB;EAClC,iBAAiB;EACjB,aAAa;AACf;;AAEA,2DAA2D;AAC3D;EACE,WAAW;EACX,sBAAsB,EAAE,oDAAoD;AAC9E;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,0BAA0B;EACnD,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oDAAoD;EACpD,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa,EAAE,wBAAwB;AACzC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB,EAAE,0BAA0B;EAC5C,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,sCAAsC;EACrD,gBAAgB,EAAE,sBAAsB;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAE,iDAAiD;EACpE,oBAAoB,EAAE,yCAAyC;AACjE;;AAEA;EACE,sDAAsD;EACtD;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW,EAAE,0BAA0B;EACzC;EACA;IACE,sBAAsB,EAAE,0BAA0B;EACpD;AACF;;AAEA,+CAA+C;;AAE/C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yCAAyC;;AAEzC;;EAEE,WAAW;EACX,aAAa;EACb,6BAA6B,EAAE,4BAA4B;EAC3D,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;;EAEb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB,EAAE,yBAAyB;EAC3C,WAAW;EACX,eAAe,EAAE,yBAAyB;EAC1C,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sCAAsC;AACtC;EACE;IACE,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Add this class to your style.css */\n.legend-item .legend-icon.my-views {\n  border-color: #808080;\n  box-shadow: 0 0 10px rgba(128, 128, 128, 0.5);\n  object-fit: cover;\n}\n\n/* Existing CSS remains unchanged */\n.legend-item .legend-icon.republican {\n  border-color: rgba(123, 6, 30, 0.66);\n  box-shadow: 0 0 10px rgba(123, 6, 30, 0.66);\n  object-fit: cover;\n}\n\n.legend-item .legend-icon.democrat {\n  border-color: #458BEA;\n  box-shadow: 0 0 10px rgba(69, 139, 234, 0.5);\n  object-fit: cover;\n}\n\n.legend-item .legend-icon.independent {\n  border-color: #808080;\n  box-shadow: 0 0 10px rgba(128, 128, 128, 0.5);\n  object-fit: cover;\n}\n\n.legend-icon {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin-bottom: 5px;\n  border: 3px solid transparent;\n  object-fit: cover;\n}\n\n.legend-container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  width: 100%;\n  gap: 20px; /* Add gap between items */\n}\n\n.legend-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 10px;\n  width: 140px; /* Increased from 120px */\n  min-height: 110px; /* Slightly increased to accommodate more text */\n}\n\n.legend-item .legend-icon,\n.add-rep-circle {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin-bottom: 5px;\n}\n\n.legend-item .legend-icon {\n  border: 3px solid transparent;\n  object-fit: cover;\n}\n\n.legend-item p {\n  font-size: 0.8em;\n  margin-top: 5px;\n  word-wrap: break-word;\n  max-width: 100%;\n  white-space: normal;\n  display: -webkit-box;\n  -webkit-line-clamp: 3; /* Allow up to 3 lines */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  line-height: 1.2em;\n  height: 3.6em; /* 3 lines × 1.2em line-height */\n}\n\n.add-rep-item {\n  position: relative;\n  width: 140px; /* Match the width of other legend items */\n  cursor: pointer;\n}\n\n.add-rep-circle {\n  background-color: #f0f0f0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: background-color 0.3s ease;\n  cursor: pointer; /* Add cursor pointer to show it's clickable */\n}\n\n.add-rep-circle:hover {\n  background-color: #e0e0e0; /* Optional: add hover effect */\n}\n\n.add-rep-circle span {\n  color: #666;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.add-rep-search {\n  position: absolute;\n  left: 100%;\n  top: 0;\n  width: 400px; /* Increased width */\n  margin-left: 10px;\n  z-index: 1000;\n}\n\n/* Add this new rule to ensure the input takes full width */\n.add-rep-search input {\n  width: 100%;\n  box-sizing: border-box; /* This ensures padding doesn't increase the width */\n}\n\n.add-rep-search .suggestions-list {\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  border: 1px solid #ccc;\n  border-top: none;\n  background-color: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.add-rep-search .suggestions-list li {\n  padding: 8px;\n  cursor: pointer;\n}\n\n.add-rep-search .suggestions-list li:hover {\n  background-color: #f0f0f0;\n}\n\n.add-rep-button {\n  background: none;\n  border: none;\n  color: #458BEA;\n  font-size: 1em;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.add-rep-button:hover {\n  text-decoration: underline;\n}\n\n.compare-reps-container {\n  max-width: 1512px;\n  display: flex;\n  width: 100%;\n  padding: 88px 150px;\n  gap: 39px;\n  background-color: white;\n}\n\n.compare-reps-header {\n  width: 100%;\n  background: linear-gradient(180deg, #458BEA 0%, #6CA8FF 100%);\n  color: white;\n  text-align: center;\n  padding: 40px 0;\n}\n\n.compare-reps-header h1 {\n  font-size: 3em;\n  font-family: 'Georgia', serif;\n  font-weight: 700;\n  margin: 0;\n}\n\n.compare-reps-header p {\n  font-size: 1.25em;\n  font-weight: 400;\n  margin: 10px 0 0 0;\n}\n\n.compare-reps-content {\n  flex: 1;\n  margin-right: 20px;\n}\n\n.instructions {\n  font-size: 1.2em;\n  font-weight: 400;\n  margin-bottom: 20px;\n  color: black;\n\n}\n\n.dropdown-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start; /* Changed to align left */\n  gap: 15px;\n}\n\n.dropdown {\n  width: 100%;\n  max-width: 400px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  box-shadow: 0px 4px 18.8px -3px rgba(0, 0, 0, 0.102);\n  border-radius: 8px;\n  border: 1px solid #D9D9D9;\n  padding: 0px;\n  position: relative;\n}\n\n.dropdown label {\n  display: none; /* Hide the label text */\n}\n\n.dropdown select {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #D9D9D9;\n  border-radius: 5px;\n}\n\n.dropdown select::placeholder {\n  color: #6C6C6C;\n}\n\n.remove-rep-button {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: none;\n  border: none;\n  color: #ff4d4d;\n  font-size: 20px;\n  font-weight: bold;\n  cursor: pointer;\n  padding: 0;\n  line-height: 1;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.3s ease;\n}\n\n.remove-rep-button:hover {\n  background-color: rgba(255, 77, 77, 0.1);\n}\n\n.checkbox-container {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.checkbox-container input {\n  width: 20px;\n  height: 20px;\n}\n\n.checkbox-container label {\n  font-size: 1em;\n  font-weight: 400;\n  color: #616161;\n}\n\n.submit-button {\n  background-color: #458BEA !important;\n  color: white;\n  font-size: 1em;\n  font-weight: 700;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.submit-button:hover {\n  background-color: #357ACD !important;\n}\n\n.scores-container {\n  text-align: left; /* Changed to align left */\n  width: 100%;\n}\n\n.separator {\n  border: none;\n  border-top: 1px solid #D9D9D9;\n  margin: 20px 0;\n}\n\n.rep-scores {\n  margin-bottom: 20px;\n}\n\n.rep-scores img {\n  max-width: 300px;\n  height: auto;\n  display: block;\n  margin: 10px auto;\n}\n\n.back-button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  border: none;\n  background-color: #458BEA;\n  color: white;\n  font-size: 16px;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n/* Additional CSS for RepresentativeBanner */\n.RepresentativeBanner {\n  position: relative;\n  width: 100%;\n  height: 609px; /* Set a fixed height for the banner */\n  overflow: hidden; /* Hide any overflow */\n}\n\n.placeholder-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover; /* Ensure the image covers the entire container */\n  object-position: top; /* Ensure the image starts from the top */\n}\n\n@media (max-width: 1224px) {\n  /* Styles for screens that are 1500px wide or larger */\n  .compare-reps-container {\n    display: flex;\n    padding: 20px 20px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 28px;\n    width: 100%; /* Changed to align left */\n  }\n  .scores-container {\n    width: 100% !important; /* Changed to align left */\n  }\n}\n\n/* Add these styles to your existing CSS file */\n\n.input-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.search-input {\n  width: 100%;\n  padding: 0px;\n  border: none;\n  border-radius: 8px;\n  background-color: transparent;\n  font-size: 14px;\n}\n\n.search-input::placeholder {\n  color: #6C6C6C;\n  font-size: 14px;\n}\n\n.suggestions-list {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  background-color: white;\n  border-top: 1px solid #D9D9D9;\n  border-radius: 0 0 8px 8px;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 1000;\n  box-shadow: 0px 4px 18.8px -3px rgba(0, 0, 0, 0.102);\n}\n\n.suggestions-list li {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.suggestions-list li:hover {\n  background-color: #f0f0f0;\n}\n\n/* ... rest of your existing styles ... */\n\n.top-comparisons {\n\n  width: 100%;\n  padding: 20px;\n  background-color: transparent; /* Removed gray background */\n  border-radius: 8px;\n  align-self: flex-start;\n  max-width: 400px;\n}\n\n@media (min-width: 1224px) {\n  .top-comparisons {\n    width: 100%;\n    \n  }\n}\n\n.top-comparison-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 15px;\n  background-color: white;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.top-comparison-item:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 8px rgba(0, 0, 0, 0.15);\n}\n\n.rep-images {\n  display: flex;\n  justify-content: space-around;\n  width: 100%;\n  gap: 10px;\n}\n\n.rep-image-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.rep-image-container .rep-thumb {\n  position: static !important;\n  transform: none !important;\n  width: 48px !important;\n  height: 48px !important;\n  margin-bottom: 5px;\n}\n\n.rep-name {\n  font-size: 0.7em;\n  color: #333;\n  text-align: center;\n  width: 100%;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  hyphens: auto;\n  max-height: 2.4em;\n  overflow: hidden;\n  line-height: 1.2em;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  margin-top: 5px;\n}\n\n.comparison-count {\n  font-size: 0.8em; /* Slightly larger font */\n  color: #666;\n  margin-top: 8px; /* Increased top margin */\n  font-weight: 500; /* Made it a bit bolder */\n}\n\n.legend-icon.grayed-out,\n.score-thumb.grayed-out {\n  opacity: 0.5;\n}\n\n.add-rep-circle {\n  width: 60px;\n  height: 60px;\n  background-color: #f0f0f0;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 5px;\n}\n\n.add-rep-circle span {\n  color: #666;\n  font-size: 24px;\n  font-weight: bold;\n  line-height: 1;\n}\n\n.add-rep-search {\n  margin-top: 10px;\n  width: 100%;\n  max-width: 500px;\n}\n\n.add-rep-search input {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.add-rep-search .suggestions-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  border: 1px solid #ccc;\n  border-top: none;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.add-rep-search .suggestions-list li {\n  padding: 8px;\n  cursor: pointer;\n}\n\n.add-rep-search .suggestions-list li:hover {\n  background-color: #f0f0f0;\n}\n\n/* Ensure the legend container doesn't overflow */\n.legend-container {\n  position: relative;\n  overflow: visible;\n}\n\n/* Adjust layout for smaller screens */\n@media (max-width: 1224px) {\n  .add-rep-search {\n    position: static;\n    width: 100%;\n    margin-left: 0;\n    margin-top: 10px;\n  }\n}\n\n.new-rep-search-container {\n  position: absolute;\n  left: 100%;\n  top: 0;\n  width: 300px;\n  margin-left: 10px;\n  z-index: 1000;\n  background-color: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.new-rep-search-input {\n  width: 100%;\n  padding: 8px;\n  border: none;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.new-rep-suggestions-list {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.new-rep-suggestions-list li {\n  padding: 8px;\n  cursor: pointer;\n}\n\n.new-rep-suggestions-list li:hover {\n  background-color: #f0f0f0;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
